import React, {useState} from 'react';

import {PrivacyPageResult} from '../../../../server/routes/main.js'


// // Interface for page data
// interface PrivacyPageData {
//     html: string;
// }

// Interface for component props
interface PrivacyProps {
    server: string;
    pageData: unknown;
}

export default function Privacy({server, pageData}: PrivacyProps) {

	let [data, setData] = useState(pageData as PrivacyPageResult);

	return (
        <>
            <div dangerouslySetInnerHTML={{__html:data.html}} />
        </>
    )
}
